import React from 'react';
import { GetCurrentVenueCustomPaymentMethodsComponent } from '../../../generated/graphql';
import CustomPaymentMethodListView from './CustomPaymentMethodListView';

const CustomPaymentMethodList = () => {
    return (
        <GetCurrentVenueCustomPaymentMethodsComponent variables={{ onlyActive: false }}>
            {({ data: { currentVenueCustomPaymentMethods } }) => (
                <CustomPaymentMethodListView currentVenueCustomPaymentMethods={currentVenueCustomPaymentMethods} />
     )}
        </GetCurrentVenueCustomPaymentMethodsComponent>
    );
};

export default CustomPaymentMethodList;